export default __webpack_public_path__ + "180c649a057e9cedd51be2335b751f85.png";